import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1028a0d0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1028a0d0')) {
      api.createRecord('1028a0d0', component.options)
    } else {
      api.reload('1028a0d0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1028a0d0&", function () {
      api.rerender('1028a0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/newComplaint/index.vue"
export default component.exports